import { type SalesCountryLocale } from "@/config/locale";
import de from "./source.de.json";
import en from "./source.en.json";
import hr from "./generated-copy/hr.json";
import el from "./generated-copy/el.json";
import hu from "./generated-copy/hu.json";
import sk from "./generated-copy/sk.json";
import bg from "./generated-copy/bg.json";
import sl from "./generated-copy/sl.json";
import ro from "./generated-copy/ro.json";
import fi from "./generated-copy/fi.json";
import lv from "./generated-copy/lv.json";
import et from "./generated-copy/et.json";
import lt from "./generated-copy/lt.json";

export type RuntimeExtraKey = keyof typeof de | keyof typeof en;
export type RuntimeExtraCopy = Record<RuntimeExtraKey, string>;
export const runtimeExtraKeys = [...Object.keys(de), ...Object.keys(en)] as RuntimeExtraKey[];
const generated: Record<SalesCountryLocale, unknown> = { hr, el, hu, sk, bg, sl, ro, fi, lv, et, lt };

/** Empty slots are deliberately unavailable until separately reviewed addon jobs are installed. */
export function validateRuntimeExtraCopy(value: unknown, locale: string): RuntimeExtraCopy {
	if (
		!value ||
		typeof value !== "object" ||
		Array.isArray(value) ||
		Object.keys(value).length !== runtimeExtraKeys.length ||
		!runtimeExtraKeys.every(
			(key) =>
				Object.hasOwn(value, key) &&
				typeof (value as Record<string, unknown>)[key] === "string" &&
				(value as Record<string, string>)[key].trim(),
		)
	) {
		throw new Error(`[i18n] Incomplete runtime addon for ${locale}; expected exactly six reviewed strings`);
	}
	return value as RuntimeExtraCopy;
}
export function getRuntimeExtraCopy(locale: SalesCountryLocale): RuntimeExtraCopy {
	return validateRuntimeExtraCopy(generated[locale], locale);
}
